// src/calendar/calendarApi.ts
import { apiClient } from "@maat/api-base";
var calendarApi = {
  getWorkspaceOccupancy: async (months) => {
    return apiClient.get("/main/api/calendar/occupancy", { params: { months } });
  }
};

export {
  calendarApi
};
